<template>

  <v-layout

  >
   

    <DialogMap
        v-if="map == true"
        v-bind:lat="Number(lat)"
        v-bind:lng="Number(lng)"
        @reset="openMapReset"
    >

    </DialogMap>


  <v-card
      class="mx-auto justify-center text-center"
      width="600"
      style="padding-top: 30px;"

      elevation-10
  >
    <v-card-title primary-title class="justify-center">
      <div>
        <h3 class="headline text--accent-2">{{ this.title }}</h3>
      </div>
    </v-card-title>


<v-form
    autocomplete="off"
>


    <v-text-field
        v-model="company"
        sm="12"
        md="4"
        label="Firma"
        required
        outlined
        type="search"
        autocomplete="off"
        @input="debouncedCheckDuplicates"
        :error-messages="companyErrorMessages"
        :error="hasCompanyErrors"
        :hint="duplicateHint"
        persistent-hint
        style="
        display: table;
        margin: 0 auto;
        width: 350px;"
    >
      <template v-slot:append>
        <v-icon v-if="duplicateCheckStatus === 'checking'" color="warning" small>
          mdi-loading mdi-spin
        </v-icon>
        <v-icon v-else-if="duplicateCheckStatus === 'duplicates-found'" color="error" small>
          mdi-alert-circle
        </v-icon>
        <v-icon v-else-if="duplicateCheckStatus === 'safe'" color="success" small>
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="grey" small>
          mdi-information
        </v-icon>
      </template>
    </v-text-field>


    <v-text-field
        v-model="street"
        sm="12"
        md="4"
        label="Strasse"
        required
        outlined
        type="search"
        autocomplete="off"
        @input="debouncedCheckDuplicates"
        style="
        display: table;
        margin: 0 auto;
        width: 350px;"

    ></v-text-field>

    <v-text-field
      v-model="city"
      sm="12"
      md="4"
      label="Ort"
      required
      outlined
      type="search"
      autocomplete="off"
      @input="debouncedCheckDuplicates"
      style="
      display: table;
      margin: 0 auto;
      width: 350px;"

  ></v-text-field>

      <v-text-field
      v-model="zipcode"
      sm="12"
      md="4"
      label="PLZ"
      required
      outlined
      type="search"
      autocomplete="off"
      @input="debouncedCheckDuplicates"
      style="
      display: table;
      margin: 0 auto;
      width: 350px;"

  ></v-text-field>

    <v-text-field
        v-model="phone"
        sm="12"
        md="4"
        label="Telefon"
        required
        outlined
        type="search"
        placeholder="+491234567890"
        autocomplete="off"
        style="
      display: table;
      margin: 0 auto;
      width: 350px;"

    ></v-text-field>

    <v-text-field
        v-model="email"
        sm="12"
        md="4"
        label="E-Mail"
        required
        outlined
        type="search"
        autocomplete="false"
        style="
      display: table;
      margin: 0 auto;
      width: 350px;"

    ></v-text-field>


    <v-textarea
      v-model="note"
      outlined
      label="Bemerkungen"
      value=""
      style="
      display: table;
      margin: 0 auto;
      width: 350px;"
  ></v-textarea>

  <div
      style="padding: 10px;"
  ></div>

  <v-text-field
      v-model="last_pickup"
      sm="12"
      md="4"
      label="Letzte Abholung"
      readonly
      outlined
      type="search"
      autocomplete="false"
      style="
      display: table;
      margin: 0 auto;
      width: 350px;"

  ></v-text-field>


  <v-text-field
      v-model="volume_year"
      sm="12"
      md="4"
      label="Laufendes Jahr Abholungen"
      readonly
      outlined
      type="search"
      autocomplete="false"
      style="
      display: table;
      margin: 0 auto;
      width: 350px;"

  ></v-text-field>


  <div
  style="padding: 10px;"
  ></div>

  <div
  v-if="reRenderer"
  >

  <CustomSelect
      v-model="group_main"
      v-bind:table="'group_main'"
      v-bind:field_text="'name'"
      v-bind:field_value="'id'"
      v-bind:label="'Kundengruppe'"
      v-bind:selected="group_main_id"

      style="
        display: table;
        margin: 0 auto;
        width: 350px;"
  ></CustomSelect>

  <CustomSelect

      v-if="group_main_id != ''"

      v-model="group_type"
      v-bind:table="'group_type'"
      v-bind:field_text="'name'"
      v-bind:field_value="'id'"
      v-bind:label="'Untergruppe'"
      v-bind:selected="group_type_id"
      v-bind:extension="'WHERE group_main_id=\'' + group_main_id + '\''"
      style="
        display: table;
        margin: 0 auto;
        width: 350px;"
  ></CustomSelect>

  </div>

  <div
      style="padding: 10px;"
  ></div>

  <v-divider></v-divider>

  <div
      style="padding: 10px;"
  ></div>

  <v-text-field
      v-model="lat"
      sm="12"
      md="4"
      label="lat (Geographische Breite)"
      required
      outlined
      type="search"
      autocomplete="false"
      style="
      display: table;
      margin: 0 auto;
      width: 300px;"

  ></v-text-field>

  <v-text-field
      v-model="lng"
      sm="12"
      md="4"
      label="lng (Geographische Länge)"
      required
      outlined
      type="search"
      autocomplete="false"
      style="
      display: table;
      margin: 0 auto;
      width: 300px;"

  ></v-text-field>


  <v-btn
      @click="openMap"
      style="margin-right: 10px;"
  ><v-icon>mdi-map</v-icon></v-btn>

  <v-btn
      @click="getGeoData"
  ><v-icon>mdi-map-marker-question-outline</v-icon></v-btn>

  <div
      style="padding: 10px;"
  ></div>

  <v-divider></v-divider>

  <div
      style="padding: 10px;"
  ></div>

  <h3>Sonstiges</h3>

<br>


  <v-switch
v-model="onlysprinter"
label="Nur Sprinter"
style="
      display: table;
      margin: 0 auto;
      width: 300px;"
>
</v-switch>

  <v-switch
      v-model="tour_notification"
      label="E-Mail bei Tourplanung"
      style="
      display: table;
      margin: 0 auto;
      width: 300px;" 
  >
  </v-switch>

  <v-divider></v-divider>


  <div
      style="padding: 10px;"
  ></div>


  <v-text-field
      v-model="cis_email"
      sm="12"
      md="4"
      label="CIS E-Mail"
      readonly
      outlined
      type="email"
      autocomplete="false"
      style="
      display: table;
      margin: 0 auto;
      width: 300px;"

  ></v-text-field>


  <v-text-field
      v-model="cis_password"
      sm="12"
      md="4"
      label="CIS Password"
      readonly
      outlined
      type="text"
      autocomplete="false"
      style="
      display: table;
      margin: 0 auto;
      width: 300px;"

  ></v-text-field>

<v-divider></v-divider>

<div style="padding: 10px;"></div>

<h3>Kundenstatus</h3>

<v-row>
  <v-col cols="6">
    <h4>Aktueller Status</h4>
    <v-radio-group 
      v-model="isCustomer"
      style="margin: 0 auto; width: 250px;"
    >
      <v-radio
        label="Potenzial"
        value="0"
        color="orange"
      ></v-radio>
      <v-radio
        label="Kunde"
        value="1"
        color="green"
      ></v-radio>
    </v-radio-group>
  </v-col>

  <v-col cols="6">
    <h4>Kundenhistorie</h4>
    <v-radio-group 
      v-model="customer_before"
      style="margin: 0 auto; width: 250px;"
    >
      <v-radio
        label="Unbekannt"
        value="unknown"
        color="grey"
      ></v-radio>
      <v-radio
        label="Ehemaliger Kunde"
        value="yes"
        color="grey"
      ></v-radio>
      <v-radio
        label="Neuer Kunde"
        value="no"
        color="grey"
      ></v-radio>
    </v-radio-group>
  </v-col>
</v-row>

<v-divider></v-divider>




  <div
      style="padding: 10px;"
  ></div>




    <!--
    </v-col>
    -->

  <v-row
  style="padding: 10px"
  >

  <v-col
      sm="2"
      md="2"
      class="text-left"
  >
    <v-btn
        v-if="id != ''"

        color="#383083"
        elevation="2"
        outlined
        style="margin-right: 40px"
        @click="btnAddTask"
    >Neuer Auftrag</v-btn>
  </v-col>



    <v-col
        sm="10"
        md="10"
        class="text-right"
    >

    <v-btn
          color="red"
          elevation="2"
          outlined
          style="margin-right: 40px"
          @click="btnCancel"
      >Abbrechen</v-btn>


    <v-btn
        color="green"
        elevation="2"
        outlined
        @click="saveData"
    >Speichern</v-btn>


    </v-col>

  </v-row>

  <div
      style="padding: 10px;"
  ></div>


</v-form>

    <v-spacer />


  </v-card>


    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbar_color"

    >
      {{ snackbar_title }}
<!--
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
 -->

    </v-snackbar>


  </v-layout>

</template>

<script>

import CustomSelect from '../components/CustomSelect'
import DialogMap from "@/components/DialogMap";
import Vue from "vue";

let fuzz
try {
  fuzz = require('fuzzball')
} catch (e) {
  try {
    const fuzzballModule = require('fuzzball')
    fuzz = fuzzballModule.default || fuzzballModule
  } catch (e2) {
    console.error('Could not load fuzzball:', e2)
  }
}

export default {
  name: "FormCustomer",

  components:{
    CustomSelect,
    DialogMap,
  },

  data () {
    return {

      title: 'Kunden',
      mainview: 'ListCustomer',
      table: 'customer',

      snackbar: false,
      snackbar_title: 'Gespeichert!',
      snackbar_color: 'red',
      timeout: 2500,

      map: false,

      group_main: '',
      group_main_id: '',
      group_main_text: '',

      cis_email: '',
      cis_password: '',

      last_pickup: '',
      volume_year: '',


      reRenderer: true,

      group_type: '',
      group_type_id: '',
      group_type_text: '',

      onlysprinter: false,
      tour_notification: 0,
      customer_before: 'unknown',


      id: '',
      company: '',
      street: '',
      zipcode: '',
      city: '',
      phone: '',
      email: '',
      note: '',
      lat: '',
      lng: '',
      isCustomer: '1', 
      lastConversation: null,
      isInterest: 'Unknown',

      repeatTask: false,

      potentialDuplicates: [],
      allCustomers: [],
      duplicateThreshold: 75,
      debounceTimer: null,
      

      duplicateCheckStatus: 'idle', // 'idle', 'checking', 'safe', 'duplicates-found'
      showDebugInfo: false,
      lastCheckTime: null,
    }
  },

  computed: {
    duplicateWarning() {
      if (this.potentialDuplicates.length > 0) {
        const exactDuplicate = this.potentialDuplicates.find(dup => dup.companyMatch && dup.addressMatch);
        if (exactDuplicate) {
          return [`Exaktes Duplikat gefunden!`]
        }
        if (this.potentialDuplicates.some(dup => dup.addressMatch)) {
          return [`An dieser Adresse existiert bereits ein Kunde!`]
        }
        return []
      }
      return []
    },
    
    companyErrorMessages() {
      return this.duplicateWarning
    },
    
    hasCompanyErrors() {
      // Show error for address duplicates (any address match is an error)
      if (this.potentialDuplicates.length > 0) {
        const addressDuplicate = this.potentialDuplicates.find(dup => dup.addressMatch);
        return !!addressDuplicate
      }
      return false
    },
    
    duplicateHint() {
      if (this.duplicateCheckStatus === 'checking') {
        return 'Prüfe auf Duplikate...'
      }
      
      if (this.duplicateCheckStatus === 'duplicates-found' && this.potentialDuplicates.length > 0) {
        const exactDup = this.potentialDuplicates.find(dup => dup.addressMatch && dup.companyMatch);
        const addressDup = this.potentialDuplicates.find(dup => dup.addressMatch && !dup.companyMatch);
        
        if (exactDup) {
          return `🚨 DUPLIKAT: "${exactDup.company}" existiert bereits an dieser Adresse`
        }
        if (addressDup) {
          return `⚠️ DUPLIKAT: An dieser Adresse existiert bereits "${addressDup.company}"`
        }
      }
      
      if (this.duplicateCheckStatus === 'safe') {
        // Check if we have company duplicates at different addresses
        const companyOnlyDup = this.potentialDuplicates.find(dup => dup.companyMatch && !dup.addressMatch);
        if (companyOnlyDup) {
          return ``
        }
        return 'Keine Duplikate gefunden'
      }
      return ''
    }
  },

  async created() {
    localStorage.loadCustomer = ""

    if(this.$route.params.id != undefined){
      this.id = this.$route.params.id
      this.loadData()
    }


    await this.checkRepeatTaskExist().then((result) => {
      this.repeatTask = result
    })

    await this.loadAllCustomers()
  },
  mounted() {
    if (this.id) {
      this.fetchLastPickupDate();
      this.fetchYearlyTireQuantity();
      this.fetchCisUserData();
    }
  },

  methods:{

    async loadAllCustomers() {
      try {
        const param = {
          table: "customer",
          statement: "select",
          type: "list",
          where: "false",
          selector: "",
          value: "",
          extension: "",
        };

        var data = {}
        const result = await this.$func.queryAPI(param, data); // Fetch customer data
        console.log("API Result for customers:", result); // Debug log for API response

        // Ensure result is an array; fallback to an empty array if invalid
        this.allCustomers = Array.isArray(result) ? result : [];
        console.log("Loaded customers:", this.allCustomers); // Debug log for loaded customers
      } catch (error) {
        console.error("Error loading customers:", error);
        this.allCustomers = [];
      
      }
    },

    debouncedCheckDuplicates() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      
      this.debounceTimer = setTimeout(() => {
        this.checkForDuplicates()
      }, 500)
    },

    async checkForDuplicates() {
        console.log("🔍 Starting comprehensive duplicate check...");
        console.log("Current Input Data:", {
          company: this.company,
          street: this.street,
          zipcode: this.zipcode,
          city: this.city,
          isEditing: !!this.id
        });

        if (this.id && this.id !== '') {
          console.log("✅ Editing existing customer - skipping duplicate check");
          this.potentialDuplicates = [];
          this.duplicateCheckStatus = "idle";
          return;
        }

        // Need at least company name to check
        if (!this.company || this.company.trim().length < 3) {
          console.log("⚠️ Company name too short, skipping duplicate check");
          this.potentialDuplicates = [];
          this.duplicateCheckStatus = "idle";
          return;
        }

        // Check if we have complete address data
        const hasCompleteAddress = this.street && this.zipcode && this.city;
        
        if (!hasCompleteAddress) {
        
          this.potentialDuplicates = [];
          this.duplicateCheckStatus = "idle";
          return;
        }

        this.duplicateCheckStatus = "checking";
        this.lastCheckTime = new Date();
        
        // Clear previous duplicates
        this.potentialDuplicates = [];
        
        // Filter out current customer if editing
        const customersToCheck = this.allCustomers.filter(c => {
          if (!c || !c.id) return false;
          if (this.id && c.id === this.id) return false;
          return true;
        });

        console.log(`Checking against ${customersToCheck.length} existing customers`);

        let hasAddressDuplicate = false;
        let hasExactDuplicate = false;
        let hasCompanyDuplicate = false;

        customersToCheck.forEach(existingCustomer => {
          if (!existingCustomer) return;

          // Skip if existing customer doesn't have complete address
          if (!existingCustomer.street || !existingCustomer.zipcode || !existingCustomer.city) {
            return;
          }

          // 1. Check company name similarity
          const companyScore = this.calculateSimilarity(
            this.normalizeString(this.company),
            this.normalizeString(existingCustomer.company)
          );

          // 2. Check street similarity
          const streetScore = this.calculateSimilarity(
            this.normalizeString(this.street),
            this.normalizeString(existingCustomer.street)
          );
          
          // 3. Check postal code match (exact match)
          const zipcodeMatch = this.normalizeString(this.zipcode) === this.normalizeString(existingCustomer.zipcode);
          
          // 4. Check city similarity
          const cityScore = this.calculateSimilarity(
            this.normalizeString(this.city),
            this.normalizeString(existingCustomer.city)
          );
          
          // Check if company name matches
          const companyMatches = companyScore >= this.duplicateThreshold;
          
          // Check if address matches
          const addressMatches = streetScore >= 75 && zipcodeMatch && cityScore >= 75;
          
          // Only flag as duplicate if either company AND address match, or just address match
          if (companyMatches && addressMatches) {
            // Exact duplicate - same company AND address
            hasExactDuplicate = true;
            hasAddressDuplicate = true;
            
            this.potentialDuplicates.push({
              ...existingCustomer,
              score: Math.round((companyScore + streetScore + 100 + cityScore) / 4),
              reasons: [
                `Firma: ${companyScore}%`, 
                `Strasse: ${streetScore}%`, 
                `PLZ: 100%`, 
                `Ort: ${cityScore}%`
              ],
              duplicateType: 'Firma UND Adresse identisch',
              addressMatch: true,
              companyMatch: true,
              formattedAddress: `${existingCustomer.street || ''}, ${existingCustomer.zipcode || ''} ${existingCustomer.city || ''}`
            });
          } else if (addressMatches) {
          
            hasAddressDuplicate = true;
            
            this.potentialDuplicates.push({
              ...existingCustomer,
              score: Math.round((streetScore + 100 + cityScore) / 3),
              reasons: [
                `Strasse: ${streetScore}%`, 
                `PLZ: 100%`, 
                `Ort: ${cityScore}%`
              ],
              duplicateType: 'Adresse identisch (andere Firma)',
              addressMatch: true,
              companyMatch: false,
              formattedAddress: `${existingCustomer.street || ''}, ${existingCustomer.zipcode || ''} ${existingCustomer.city || ''}`
            });
          } else if (companyMatches) {
            // Company name duplicate only - same name at different address (ALLOWED)
            hasCompanyDuplicate = true;
            
            this.potentialDuplicates.push({
              ...existingCustomer,
              score: companyScore,
              reasons: [`Firma: ${companyScore}%`],
              duplicateType: 'Firma identisch (andere Adresse)',
              addressMatch: false,
              companyMatch: true,
              formattedAddress: `${existingCustomer.street || ''}, ${existingCustomer.zipcode || ''} ${existingCustomer.city || ''}`
            });
          }
        });

        // Sort by score (highest first)
        this.potentialDuplicates.sort((a, b) => b.score - a.score);
        
        console.log(`✅ Duplicate check results:`, {
          exactDuplicate: hasExactDuplicate,
          addressDuplicate: hasAddressDuplicate,
          companyDuplicate: hasCompanyDuplicate,
          total: this.potentialDuplicates.length
        });
        
        // Set status based on findings
        if (hasExactDuplicate) {
          this.duplicateCheckStatus = "duplicates-found";
          console.log("🚨 EXACT DUPLICATE FOUND!");
        } else if (hasAddressDuplicate) {
          this.duplicateCheckStatus = "duplicates-found";
          console.log("⚠️ ADDRESS DUPLICATE FOUND!");
        } else if (hasCompanyDuplicate) {
          // Company name only duplicate - this is allowed, so show as safe
          this.duplicateCheckStatus = "safe";
          console.log("ℹ️ Company name duplicate at different address - ALLOWED");
        } else {
          this.duplicateCheckStatus = "safe";
          console.log("✅ No duplicates found.");
        }
    },
    normalizeString(str) {
      if (!str) return ''
      
      return str
        .toLowerCase()
        .trim()
        // Normalize German characters
        .replace(/ä/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/ü/g, 'u')
        .replace(/ß/g, 'ss')
        // Remove common company suffixes for better matching
        .replace(/\s+(gmbh|ag|kg|ohg|gbr|ug|e\.v\.|ev)$/gi, '')
        // Normalize street suffixes
        .replace(/strasse$/g, 'str')
        .replace(/straße$/g, 'str')
        .replace(/platz$/g, 'pl')
        .replace(/weg$/g, 'w')
    },

    calculateSimilarity(str1, str2) {

      if (fuzz && typeof fuzz.ratio === 'function') {
        return fuzz.ratio(str1, str2)
      }
      
      // Fallback to built-in method
      console.warn('⚠️ Fuzzball not available, using fallback method')
      
      // Exact match
      if (str1 === str2) return 100

      // One string contains the other
      if (str1.includes(str2) || str2.includes(str1)) {
        return 90
      }

      // Levenshtein distance
      const longer = str1.length > str2.length ? str1 : str2
      const shorter = str1.length > str2.length ? str2 : str1
      
      if (longer.length === 0) return 100
      
      const editDistance = this.getEditDistance(longer, shorter)
      return Math.round(((longer.length - editDistance) / longer.length) * 100)
    },

    getEditDistance(str1, str2) {
      const matrix = []

      for (let i = 0; i <= str2.length; i++) {
        matrix[i] = [i]
      }

      for (let j = 0; j <= str1.length; j++) {
        matrix[0][j] = j
      }

      for (let i = 1; i <= str2.length; i++) {
        for (let j = 1; j <= str1.length; j++) {
          if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1]
          } else {
            matrix[i][j] = Math.min(
              matrix[i - 1][j - 1] + 1,
              matrix[i][j - 1] + 1,
              matrix[i - 1][j] + 1
            )
          }
        }
      }

      return matrix[str2.length][str1.length]
    },
  
    async fetchCisUserData() {
      try {
        const param = {
          table: "cis_user",
          statement: "select",
          type: "list",
          where: "true",
          selector: "customer_id",
          value: this.id,
          extension: "",
        };
        
        const result = await this.$func.queryAPI(param, {});
        console.log("CIS User Data:", result);
       
        if (result && result.length > 0) {
          this.cis_email = result[0].email;
          this.cis_password = result[0].password;
        }
      } catch (error) {
        console.error('Error fetching CIS user data:', error);
      }
    },

    async fetchYearlyTireQuantity() {
     console.log("Fetching yearly tire quantity...");

      if (!this.id) {
        console.warn("Customer ID is not set.");
        this.volume_year = 0; 
        return;
      }

      const currentYear = new Date().getFullYear();
      const startDate = `01.01.${currentYear}`;  
      const endDate = `31.12.${currentYear}`; 

      const param = {
        table: "task",
        statement: "custom",
        type: "list",
        where: "true",
        selector: "",
        extension: `SELECT SUM(pickup_qty) AS total_qty FROM task WHERE customer_id = '${this.id}' AND pickup_date >= '${startDate}' AND pickup_date <= '${endDate}' `,
      };

      const data = {};

      try {
        const result = await this.$func.queryAPI(param, data);
        console.log("API Result:", result);

        if (result && result.length > 0 && result[0].total_qty) {
          this.volume_year = result[0].total_qty; 
        } else {
          this.volume_year = 0; 
        }
      } catch (error) {
        console.error("Error fetching yearly tire quantity:", error);
        this.volume_year = "Error fetching data"; 
      }
    },



    async fetchLastPickupDate() {
      console.log("fetchLastPickupDate");
      const param = {
        table: "task",
        statement: "select",
        type: "detail",
        where: "true",
        selector: "customer_id",
        value: this.id,
        short: "true",
        extension: "ORDER BY STR_TO_DATE(pickup_date, '%d.%m.%Y') DESC LIMIT 1",
      };

      const data = {};

      const result = await this.$func.queryAPI(param, data);
      console.log("last pickup date " , result);

      if (result && result.length > 0) {
        this.last_pickup = result[0].pickup_date; 
        console.log("Last pickup date:", this.last_pickup);
      } else {
        this.last_pickup = "N/A"; 
      }
    },

    async checkRepeatTaskExist(){
      console.log("checkRepeatTaskExist")

      var param = {
        table: "task_repeat",
        statement: "select",
        type: "list",
        where: "true",
        selector: "customer_id",
        value: this.customer_id,
        short: "true",
        extension: "",
      }

      var data = {}
      var result = await this.$func.queryAPI(param, data)

      if(result.length == "0"){
        return false
      }else{
        return true
      }
    },

    btnAddTask(){
      console.log("btnAddTask")
      console.log("this.id" + this.id)

      if (this.repeatTask == true){
        alert("Es existiert bereits ein wiederkehrender Auftrag für diesen Kunden!")
        return
      }

      localStorage.loadCustomer = this.id
      this.$route.params.id = ""
      this.$router.push({ name: "FormTask" })
    },

    openMap(){
      console.log("openMap")

      if(this.lat == "" || this.lng == ""){
        this.snackbar_title = "Bitte Geo Daten eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      this.map = true

    },

    openMapReset(){
      this.map = false
    },

    getGeoData(){

      if(this.street == ""){
        this.snackbar_title = "Bitte Adresse eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      if(this.city == ""){
        this.snackbar_title = "Bitte Stadt eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      if(this.zipcode == ""){
        this.snackbar_title = "Bitte PLZ eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }


      Vue.$geocoder.setDefaultMode('address');
    
        var addressObj = {
            address_line_1: this.street,
            address_line_2: '',
            city: this.city,
            state: '',
            zip_code: this.zipcode,
            country: 'Deutschland',
            sensor: true
        }
        
        Vue.$geocoder.send(addressObj, response => {
            console.log(response)
            
            if(response["results"][0]["formatted_address"] == "Deutschland"){
                this.snackbar_title = "Adresse nicht gefunden! Bitte Adresse prüfen!"
                this.snackbar_color = "red"
                this.snackbar = true
                return
            }
            
            const googleZipcode = response["results"][0]["formatted_address"].match(/\b\d{5}\b/);
            const googleZip = googleZipcode ? googleZipcode[0] : null;
            
            // Check if zipcodes match
            if(googleZip && googleZip !== this.zipcode){
                console.log(`Zipcode mismatch: You entered ${this.zipcode}, Google found ${googleZip}`);
                
                //  Show warning but continue 
                this.snackbar_title = `Hinweis: Google Maps zeigt PLZ ${googleZip} für diese Adresse. Möchten Sie trotzdem fortfahren? (Ihre Eingabe: ${this.zipcode})`
                this.snackbar_color = "warning" 
                this.snackbar = true
                
                // Still set the coordinates
                this.lat = response["results"][0]["geometry"]["location"]["lat"]
                this.lng = response["results"][0]["geometry"]["location"]["lng"]
                
                // Save anyway (user can decide)
                if(confirm(`Die PLZ stimmt nicht überein. Google Maps zeigt ${googleZip}, Sie haben ${this.zipcode} eingegeben. Trotzdem speichern?`)){
                    this.saveData()
                }
                
                return
            }
            
            // If zipcodes match, proceed normally
            this.lat = response["results"][0]["geometry"]["location"]["lat"]
            this.lng = response["results"][0]["geometry"]["location"]["lng"] 
            
            console.log("lat: " + response["results"][0]["geometry"]["location"]["lat"])
            console.log("lng: " + response["results"][0]["geometry"]["location"]["lng"])
            console.log("formatted_address: " + response["results"][0]["formatted_address"])
            
            this.saveData()
        });
    },

    btnCancel(){
      this.$router.push({ name: this.mainview })
    },

    async loadData(){
      var param = {
        table: this.table,
        statement: "select",
        type: "detail",
        where: "true",
        selector: "id",
        value: this.id,
        short: "true",
        extension: "",
      }

      var data = {}
      var result = await this.$func.queryAPI(param, data)

      this.company = result[0]["company"]
      this.street = result[0]["street"]
      this.zipcode = result[0]["zipcode"]
      this.city = result[0]["city"]
      this.phone = result[0]["phone"]
      this.email = result[0]["email"]
      this.note = result[0]["note"]
      this.lat = result[0]["lat"]
      this.lng = result[0]["lng"]

      this.cis_email    = result[0]["cis_email"]
      this.cis_password = result[0]["cis_password"]
      this.isCustomer   = result[0]["isCustomer"] 
      this.lastConversation = result[0]["lastConversation"]
      this.isInterest   = result[0]["isInterest"]
      this.customer_before = result[0]["customer_before"] || 'unknown'
      
      if (result[0]["last_pickup"]) {
        this.last_pickup = result[0]["last_pickup"]
      } else {
        this.fetchLastPickupDate()
      }
      
      if (result[0]["volume_year"]) {
        this.volume_year = result[0]["volume_year"]
      } else {
        this.fetchYearlyTireQuantity()
      }

      if(result[0]["onlysprinter"] != ""){
        this.onlysprinter = JSON.parse(result[0]["onlysprinter"])
      }else{
        this.onlysprinter = false
      }

      if(result[0]["tour_notification"] != ""){
        this.tour_notification = JSON.parse(result[0]["tour_notification"])
      }else{
        this.tour_notification = 0
      }

      this.group_main_id = result[0]["group_main_id"]
      this.group_main_text = result[0]["group_main_text"]

      this.group_type_id = result[0]["group_type_id"]
      this.group_type_text = result[0]["group_type_text"]

      this.group_main = null
      this.group_type = null

      this.reRenderer = false

      this.$nextTick(() => {
        this.reRenderer = true
      })
      
    
      this.$nextTick(() => {
        this.debouncedCheckDuplicates()
      })
    },

    async saveData(){
      if(this.company === ""){
        this.snackbar_title = "Bitte Firmennamen eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      if(this.street === ""){
        this.snackbar_title = "Bitte Strasse eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      if(this.zipcode === ""){
        this.snackbar_title = "Bitte PLZ eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      if(this.city === ""){
        this.snackbar_title = "Bitte Stadt eingeben!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      if(this.group_main_text === ""){
        this.snackbar_title = "Bitte Kundengruppe auswählen!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      if(this.group_type_text === ""){
        this.snackbar_title = "Bitte Untergruppe auswählen!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      // Only prevent save if BOTH company AND address match (exact duplicate)
// Prevent save if address matches (same address = blocking, even if different company)
const addressDuplicate = this.potentialDuplicates.find(dup => dup.addressMatch);
if (addressDuplicate) {
  alert('⚠️ Speichern nicht möglich: An dieser Adresse existiert bereits ein Kunde: "' + addressDuplicate.company + '"')
  return
}

      var statement

      if(this.id == ""){
        statement = "insert"
      }else{
        statement = "update"
      }

      // Parameter
      var param = {
        table: this.table,
        statement: statement,
        type: "",
        where: "true",
        selector: "id",
        value: this.id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Data
      var data = {
        company: this.company,
        street: this.street,
        zipcode: this.zipcode,
        city: this.city,
        phone: this.phone,
        email: this.email,
        note: this.note,
        lat: this.lat,
        lng: this.lng,

        onlysprinter: this.onlysprinter.toString(),
        tour_notification: this.tour_notification,

        group_main_id: this.group_main_id,
        group_type_id: this.group_type_id,

        group_main_text: this.group_main_text,
        group_type_text: this.group_type_text,

        last_pickup: this.last_pickup,
        volume_year: this.volume_year,
        isCustomer: this.isCustomer,
        lastConversation: this.lastConversation,
        isInterest: this.isInterest || 'Unknown',
        customer_before: this.customer_before,
      }

      var result = await this.$func.queryAPI(param, data)

      console.log(result)

      this.snackbar_title = "Gespeichert!"
      this.snackbar_color = "green"
      this.snackbar = true

      if(statement == "insert"){
        this.id = result["value"]

        await this.loadAllCustomers()
      }

      if(localStorage.createCustomer == "1"){
        localStorage.loadCustomer = this.id
        this.$router.push({ name: "FormTask" })
      }
    }
  },

  watch:{
    group_main: function () {
      if(this.group_main == null){
        return
      }

      if(this.group_main.trim() != ";" && this.group_main.includes(";") == true){
        this.group_main_id = this.group_main.split(";")[1]
        this.group_main_text = this.group_main.split(";")[0]
      }else{
        if(this.group_main.trim() == ";"){
          this.group_main_id = ""
          this.group_main_text = ""

          this.group_type_id = ""
          this.group_type_text = ""
        }

        if (this.group_main_id == ""){
          this.group_main_id = ""
          this.group_main_text = ""

          this.group_type_id = ""
          this.group_type_text = ""
        }
      }
    },

    group_type: function () {
      if(this.group_type == null){
        return
      }

      if(this.group_type.trim() != ";" && this.group_type.includes(";") == true){
        this.group_type_id = this.group_type.split(";")[1]
        this.group_type_text = this.group_type.split(";")[0]
      }else{
        if(this.group_type.trim() == ";"){
          this.group_type_id = ""
          this.group_type_text = ""
        }

        if (this.group_type_id == ""){
          this.group_type_id = ""
          this.group_type_text = ""
        }
      }
    },
  },

  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }
}
</script>

<style scoped>

</style>